<div class="container tw-my-[5%]">
      <div class="text-center tw-mb-[5%]">
        <p class="tw-text-xl md:tw-text-2xl lg:tw-text-3xl tw-font-extrabold">Media Coverage</p>
        <p class="tw-text-grayMid tw-mt-2">Unveiling a World Beyond Headlines: Our In-Depth Media Coverage</p>
      </div>
      <div class="medias scroll-container">
          <a aria-label="View Media Coverage article" [href]="item.link" class="media tw-cursor-pointer" *ngFor="let item of mediaList"> 
              <div class="image-container">
                <img [alt]="item.title" [src]="item.image" srcset="" class="image">
              </div>
              <div class="detail-container">
                <img [src]="item.sourceLogo" alt="Company logo" srcset="" class="logo">
                <div class=" media-title">{{item.title}}</div>
                <div class="media-link">Read More...</div>
              </div>
            </a>
      </div>
</div>